module.exports = __webpack_public_path__ + "build/img/autumn2.cacc079b.png";